import { CellProps, Column, Row } from "@komune-io/g2-layout"
import { TFunction } from "i18next"
import { PlatformPaginatedTable, TableCellText } from "@tracabois/template"
import { OffsetPagination, PageQuery, PageResult } from "@tracabois/utils"
import { RemovalZone } from "../../../../removalZone/model/removalZone"
import { DeleteButton } from "@komune-io/g2-components"
import { useCallback } from "react"

interface RealizationOriginesTableProps {
  page: PageResult<RemovalZone>
  isLoading?: boolean
  editable?: boolean
  onPageQueryChange: (page: PageQuery) => void
  onRowClicked?: (row: Row<RemovalZone>) => void
  onRemoveZone?: (zone: RemovalZone) => void
}

export const RealizationOriginesTable = (props: RealizationOriginesTableProps) => {
  const { page, isLoading, editable, onPageQueryChange, onRowClicked, onRemoveZone } = props

  const onPaginationChange = (pagination: OffsetPagination) => {
    onPageQueryChange({
      pagination: pagination
    })
  }

  const getColumns = useCallback((t: TFunction): Column<RemovalZone>[] => {
    const columns: Column<RemovalZone>[] = [
      {
        Header: `${t("removalZone.name", "Label")}`,
        accessor: "name",
        Cell: ({ row }: CellProps<RemovalZone>) => (
          <TableCellText main={row.original.name || ""} />
        ),
      },
      {
        Header: `${t("removalZone.massif", "Nom")}`,
        accessor: "massif",
        Cell: ({ row }: CellProps<RemovalZone>) => (
          <TableCellText main={row.original.massif || ""} />
        ),
      },
      {
        Header: `${t("removalZone.species", "Essence")}`,
        accessor: "woodSpecies",
        Cell: ({ row }: CellProps<RemovalZone>) => (
          <TableCellText
            main={row.original.woodSpecies?.map((s) => s.name).join(", ") || ""}
          />
        ),
      },
      {
        Header: `${t("removalZone.location", "Localisation")}`,
        accessor: "department",
        Cell: ({ row }: CellProps<RemovalZone>) => {
          const location = [
            row.original.city?.name,
            row.original.department?.name,
          ].filter(Boolean).join(", ")
          return <TableCellText main={location || ""} />
        },
      },
    ]

    if (onRemoveZone) {
      columns.push({
        Header: `${t("removalZone.remove", "Supprimer")}`,
        Cell: ({ row }: CellProps<RemovalZone>) => (
          <DeleteButton
            onClick={() => onRemoveZone(row.original)}
            disabled={!editable}
          />
        ),
      })
    }

    return columns
  }, [onRemoveZone, editable])

  return (
    <PlatformPaginatedTable<RemovalZone>
      page={page}
      isLoading={isLoading}
      columnsDefinition={getColumns}
      onPageChange={onPaginationChange}
      onRowClicked={onRowClicked}
    />
  )
}
